const ENTERPRISE_CLIENTS = [
  "Meta",
  "Arvato-Bertelsmann",
  "DHL",
  "Hertz",
  "Amtrak",
];

const SECTOR_CLIENTS = [
  { icon: "ri-government-line", title: "Federal Government", desc: "Agency-level programs and secure infrastructure." },
  { icon: "ri-building-2-line", title: "State & Local Government", desc: "City, county and state technology modernization." },
  { icon: "ri-plane-line", title: "Airports", desc: "Airside and terminal systems for major aviation hubs." },
  { icon: "ri-shield-star-line", title: "Military", desc: "Defense-grade communications and security systems." },
  { icon: "ri-police-car-line", title: "Law Enforcement", desc: "Command, surveillance and evidence infrastructure." },
  { icon: "ri-building-4-line", title: "Fortune 500 Enterprise", desc: "Multi-site rollouts for global corporations." },
];

export default function Clients() {
  return (
    <section id="clients" className="relative py-20 md:py-32 bg-foreground-950 text-background-50 overflow-hidden">
      <div className="absolute inset-0 dotted-bg opacity-30"></div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-primary-400 font-semibold mb-4">
            <span className="w-8 h-px bg-primary-500"></span>
            Trusted by
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold leading-tight tracking-tight">
            Where the stakes are high, <br className="hidden md:block" />
            <span className="text-primary-400">the work has to be right.</span>
          </h2>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-background-100/75 leading-relaxed">
            Delivering for organizations where downtime, breaches or missed deadlines are
            not acceptable outcomes — from federal facilities to global logistics giants.
          </p>
        </div>

        {/* Enterprise names marquee */}
        <div className="mt-12 md:mt-16">
          <div className="text-xs uppercase tracking-widest text-background-100/60 mb-5">
            Enterprise engagements include
          </div>
          <div className="relative overflow-hidden">
            <div className="marquee-track flex gap-10 md:gap-16 whitespace-nowrap">
              {[...ENTERPRISE_CLIENTS, ...ENTERPRISE_CLIENTS, ...ENTERPRISE_CLIENTS].map((name, i) => (
                <div
                  key={`${name}-${i}`}
                  className="flex items-center gap-4 font-heading text-2xl md:text-4xl font-bold text-background-100/40 hover:text-background-50 transition-colors"
                >
                  <span>{name}</span>
                  <span className="text-primary-400 text-xl md:text-3xl">•</span>
                </div>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-foreground-950 to-transparent"></div>
            <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-foreground-950 to-transparent"></div>
          </div>
        </div>

        {/* Sector grid */}
        <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {SECTOR_CLIENTS.map((s) => (
            <div
              key={s.title}
              className="rounded-lg border border-foreground-800 bg-foreground-900/60 p-5 md:p-6 hover:border-primary-500 hover:bg-foreground-900 transition-colors"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-md bg-primary-500/15 text-primary-400 mb-4">
                <i className={`${s.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-background-50 leading-tight">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-background-100/70 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}